// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__Vq5Ez","content":"styles_content__R1KWS"};